import { X } from "lucide-react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "../../../../shared/ui";
import { Information } from "iconsax-reactjs";

type RemoveMemberFromRoleModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  memberName: string;
  reassignmentRoleName: string;
  canChooseReassignment: boolean;
  onOpenReassignmentRolesModal: () => void;
  onCancel: () => void;
  onRemoveRole: () => void;
  isSubmitting: boolean;
  error?: string | null;
};

const RemoveMemberFromRoleModal = ({
  open,
  onOpenChange,
  memberName,
  reassignmentRoleName,
  canChooseReassignment,
  onOpenReassignmentRolesModal,
  onCancel,
  onRemoveRole,
  isSubmitting,
  error,
}: RemoveMemberFromRoleModalProps) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      contentClassName="max-w-[600px]"
    >
      <ModalHeader className="absolute right-6 top-6 z-10 p-0">
        <button
          type="button"
          aria-label="Close modal"
          className="rounded-full p-2 text-[#737AA8] hover:bg-[#F2F4FF]"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          <X size={22} />
        </button>
      </ModalHeader>

      <ModalBody className="mt-5 px-8 pb-6 pt-0 text-center">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[#F5F0DD]">
          <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#F8E7B8]">
            <Information size={24} className="text-[#D97706]" />
          </div>
        </div>
        <ModalTitle className="text-center">Remove from role</ModalTitle>
        <p className="mx-auto mt-3 max-w-[560px] text-[16px] leading-7 text-[#3A3E5B]">
          {memberName} will no longer have access to this role and its
          permissions. Reassign them a new role first to avoid interruptions.
        </p>
        {error ? (
          <p className="mt-3 text-[14px] text-[#C24E4E]">{error}</p>
        ) : null}
      </ModalBody>

      <ModalFooter className="justify-between gap-4">
        <Button
          variant="ghost"
          className="h-11 rounded-[14px] px-4 text-[16px] font-[500] text-[#2C2F44]"
          onClick={onOpenReassignmentRolesModal}
          disabled={!canChooseReassignment || isSubmitting}
        >
          {reassignmentRoleName
            ? `Reassign: ${reassignmentRoleName}`
            : "Reassign role"}
        </Button>
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            className="h-11 rounded-[14px] px-6 text-[#2C2F44]"
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            className="h-11 rounded-[14px] px-6"
            onClick={onRemoveRole}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Remove role"}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default RemoveMemberFromRoleModal;
